import { render } from "./AddSong.vue?vue&type=template&id=51ed3cc9&scoped=true"
import script from "./AddSong.vue?vue&type=script&lang=js"
export * from "./AddSong.vue?vue&type=script&lang=js"

import "./AddSong.vue?vue&type=style&index=0&id=51ed3cc9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51ed3cc9"

export default script